import type { TMediaCard } from '@klv/organisms/content-carousel/types';

export const limitCards = ({ cardLimit, mediaCards }: { cardLimit: number; mediaCards: TMediaCard[]; }) => {
  const acceptedCards = [];

  for (let i = 0; i < cardLimit && i < mediaCards.length; i += 1) {
    acceptedCards.push(mediaCards[i]);
  }

  return acceptedCards;
};

